<template>
    <div>
        <b-card>
            <div class="card-text">
                <div v-if="store.feature_image">
                    <b-row>
                        <b-col lg="4" cols="12"></b-col>
                        <b-col lg="4" cols="12">
                            <b-img fluid :src="store.feature_image"></b-img>
                        </b-col>
                        <b-col lg="4" cols="12"></b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-alert show variant="info">Actualmente no tiene imagen, ¡Agregue una!</b-alert>
                    <b-card tag="article"
                            title="Foto del comercio"
                            style="max-width: 100%;"
                            class="mb-2">
                        <div class="card-text">
                            <b-row>
                                <b-col cols="12" md="8" lg="6">
                                    <b-form-file required v-model="file" :state="Boolean(file)" placeholder="Seleccione imagen" accept=".jpg, .jpeg, .png" ref="fileinput"></b-form-file> 
                                    <div v-if="file" class="mt-3">Archivo seleccionado: {{file && file.name}}</div>
                                    <div v-else class="mt-3"> Sin seleccionar archivo</div>
                                    <br>
                                </b-col>
                                <b-col cols="12" md="4" lg="6">
                                    <b-btn class="btn-block-xs-only" :disabled="!file" variant="primary" @click="uploadPhoto"><i class="fa fa-cloud-upload"></i> Guardar foto</b-btn>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import storeRepository from '../../../../repositories/stores.repository.js';
import {mapGetters, mapMutations} from 'vuex';
import * as mutations from '../../../../store/commitTypes';
export default {
    props: {
        store: {
            required: true
        }
    },
    data(){
        return {
            file: ''
        }
    },
    computed: {
        ...mapGetters(['selectedStore'])
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        uploadPhoto(){
            const formData = new FormData();

            formData.append('storeId', this.store.id);

            if(this.file){
                formData.append('file', this.file);
            }

            const sr = { ...storeRepository};

            sr.uploadPhoto(formData)
            .then(({data}) => {
                if(data.status){
                    this.setSelectedStore(data.store);
                    toastr.success(data.msg);
                }else{
                    toastr.error(data.msg);
                }
            })
            .catch(error => {
                toastr.error('Error al guardar la foto');
            });
        }
    }
}
</script>

